var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26396_248957",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26396_248957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66595 4.66667C4.66595 2.64267 6.30862 1 8.33262 1H11.9993V8.33333H8.33262C6.30862 8.33333 4.66595 6.69067 4.66595 4.66667Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0008 1H15.6674C17.6914 1 19.3341 2.64267 19.3341 4.66667C19.3341 6.69067 17.6914 8.33333 15.6674 8.33333H12.0008V1Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66595 12C4.66595 9.976 6.30862 8.33333 8.33262 8.33333H11.9993V15.6667H8.33262C6.30862 15.6667 4.66595 14.024 4.66595 12Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3341 12C19.3341 14.024 17.6914 15.6667 15.6674 15.6667C13.6434 15.6667 12.0008 14.024 12.0008 12C12.0008 9.976 13.6434 8.33333 15.6674 8.33333C17.6914 8.33333 19.3341 9.976 19.3341 12Z",
    fill: "#1ABCFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33262 23C10.3566 23 11.9993 21.3573 11.9993 19.3333V15.6667H8.33262C6.30862 15.6667 4.66595 17.3093 4.66595 19.3333C4.66595 21.3573 6.30862 23 8.33262 23Z",
    fill: "#0ACF83"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/Figma.cb4961b6b5a8074fc0d7ec510b1a2567.svg";
export { ForwardRef as ReactComponent };